/**
 * loading.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
 */

import * as React from "react";

export function LoadingView(): React.ReactElement<any, any> {
  return <div className="loading-splash">
    <div className="splash-logo" />
  </div>;
}